const initBanner = () => {
  const banners = document.querySelectorAll(
    ".Banner:has(.Banner--dynamic-nav)"
  );

  banners.forEach((banner) => {
    const items = banner.querySelectorAll(".Banner--dynamic-nav-item");
    const slides = banner.querySelectorAll(".Banner--slide");

    items.forEach((item, id) => {
      const trigger = item.querySelector(".Banner--title");

      trigger.addEventListener("click", openBanner);

      function openBanner() {
        if (item.classList.contains("Active")) return;

        items.forEach((item) => {
          deactivate(item);
        });

        slides.forEach((slide) => {
          deactivate(slide);
        });

        activate(item);
        activate(slides[id]);
      }
    });

    function activate(item) {
      item.classList.add("Active");
      item.classList.remove("LastActive");
    }

    function deactivate(item) {
      item.classList.remove("Active");
      item.classList.add("LastActive");

      setTimeout(() => {
        item.classList.remove("LastActive");
      }, 500);
    }
  });
};

initBanner();
